import yup from 'core/utils/validators';
import { FIELD_REQUIRED } from 'const';

const { object, number } = yup;

export const SubmitCalculatorFormSchema = () => {
  return object().shape({
    loan_purpose: number().required(FIELD_REQUIRED),
  });
};
